var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-43ab2af0"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { key: 0 };
var _hoisted_2 = { class: "text-center" };
var _hoisted_3 = { class: "text-center mt-4" };
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import kardiasschema from "@/../../EshJSLib/models/form/kardias.json";
import fileschema from "@/../../EshJSLib/models/form/files.json";
import checkMeProView from "../ble/view/CheckMeProView.vue";
import dHeart from "../ble/view/DHeart.vue";
import { saveFile, deleteFile, updateFile } from "@/../../EshJSLib/services/fileServices";
import { ref, onMounted, reactive } from "vue";
import { Modal } from "flowbite-vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import ModalNewFile from "./modal_addnewfile.vue";
import ModalEditFile from "./modal_editfile.vue";
import ModalKardiaPreview from "./modal_anteprima.vue";
import ModalDeleteFile from "./modal_delete.vue";
import ModalConfidenzialita from "./modal_confidenzialita.vue";
import { previewKardia } from "@/../../EshJSLib/services/kardiaServices";
import { useRouter } from "vue-router";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";
export default /*#__PURE__*/ _defineComponent({
    __name: 'fileDispositiviPage',
    setup: function (__props) {
        var _this = this;
        var router = useRouter();
        var isShownModalSub = reactive({
            alert: false,
            movePage: false,
            confirm: false,
            alertMove: false,
        });
        function movePage() {
            router.push({ path: 'Paypal' });
        }
        //Ref Element with HTML
        var alertModal = ref(null);
        var modalEditFile = ref(null);
        var modalKardiaPreview = ref(null);
        var modalDeleteFile = ref(null);
        var modalConfidenzialita = ref(null);
        var modalAddFile = ref(null);
        var data = ref({});
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var modal_status = reactive({});
        var showLoading = ref(false);
        var imageDataUrl = ref("");
        var filenew = reactive({
            id_paziente: patient.value.id_paziente,
            id_autore: patient.value.id_paziente,
            id_audit_log: 1,
            id_file: null,
            file_commento: '',
            file_nome: '',
            file_type: '',
            file: null,
            type: '',
            tags: '',
            file_size: 0,
            data_rilievo: null,
            id_livello_confidenzialita: 1,
        });
        // const props = defineProps({
        //     data: CollapsableModel,
        // });
        var schema = ref('');
        function action(type, row) {
            var _a, _b, _c, _d, _e, _f;
            return __awaiter(this, void 0, void 0, function () {
                var userInput, _g, downloadData, id_tipo_licenza, e_1;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            _g = type;
                            switch (_g) {
                                case "eye": return [3 /*break*/, 1];
                                case "download": return [3 /*break*/, 2];
                                case "trash": return [3 /*break*/, 6];
                                case "pen": return [3 /*break*/, 7];
                                case "lock": return [3 /*break*/, 12];
                                case "newRecord": return [3 /*break*/, 14];
                            }
                            return [3 /*break*/, 23];
                        case 1:
                            // userInput = await modalKardiaPreview.value?.openModal("Kardia", true, row);
                            // if (userInput) {
                            previewKardia(row.id_file);
                            // }
                            return [3 /*break*/, 24];
                        case 2: return [4 /*yield*/, ((_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Scaricare il File?", true))];
                        case 3:
                            userInput = _h.sent();
                            if (!userInput) return [3 /*break*/, 5];
                            showLoading.value = true;
                            return [4 /*yield*/, store.fetchDownloadUrl(row.id_file)];
                        case 4:
                            downloadData = _h.sent();
                            window.open(downloadData.data, "_blank");
                            showLoading.value = false;
                            (_b = alertModal.value) === null || _b === void 0 ? void 0 : _b.openModal("File scaricato con successo! ", false);
                            _h.label = 5;
                        case 5: return [3 /*break*/, 24];
                        case 6:
                            alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then(function (userInput) {
                                if (userInput) {
                                    row.status = 'delete';
                                    showLoading.value = true;
                                    deleteFile(row.id_file)
                                        .then(function (response) {
                                        var _a;
                                        showLoading.value = false;
                                        if (response.status === 200) {
                                            (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("File eliminato con successo!", false);
                                        }
                                        store.fetchFiles();
                                        store.fetchKardias();
                                    })
                                        .catch(function (error) {
                                        var _a;
                                        showLoading.value = false;
                                        (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Non puoi eliminare questo file", false);
                                        store.fetchFiles();
                                        store.fetchKardias();
                                    });
                                }
                            });
                            return [3 /*break*/, 24];
                        case 7: return [4 /*yield*/, hasPermission('modificafile')];
                        case 8:
                            if (!_h.sent()) return [3 /*break*/, 10];
                            return [4 /*yield*/, ((_c = modalEditFile.value) === null || _c === void 0 ? void 0 : _c.openModal("Modifica file", true, row))];
                        case 9:
                            userInput = _h.sent();
                            if (userInput) {
                                showLoading.value = true;
                                updateFile(row).then(function () {
                                    var _a;
                                    showLoading.value = false;
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("File cambiato con successo!", false);
                                    store.fetchFiles();
                                    store.fetchKardias();
                                });
                            }
                            return [3 /*break*/, 11];
                        case 10:
                            isShownModalSub.alert = true;
                            _h.label = 11;
                        case 11: return [3 /*break*/, 24];
                        case 12: return [4 /*yield*/, ((_d = modalConfidenzialita.value) === null || _d === void 0 ? void 0 : _d.openModal("Seleziona il livello di confidenzialità ", true, row))];
                        case 13:
                            userInput = _h.sent();
                            if (userInput) {
                                showLoading.value = true;
                                updateFile(row).then(function () {
                                    var _a;
                                    showLoading.value = false;
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Confidenzialità modificata con successo!", false);
                                });
                            }
                            return [3 /*break*/, 24];
                        case 14:
                            id_tipo_licenza = patient.value.sottoscrizione.id_tipo_licenza;
                            return [4 /*yield*/, hasPermission('aggiungifile')];
                        case 15:
                            if (!_h.sent()) return [3 /*break*/, 21];
                            filenew = {
                                id_paziente: patient.value.id_paziente,
                                id_autore: patient.value.id_paziente,
                                id_audit_log: 132,
                                id_file: null,
                                file_commento: '',
                                file_nome: '',
                                file_type: '',
                                file: null,
                                type: '',
                                tags: '',
                                file_size: 0,
                                data_rilievo: null,
                                id_livello_confidenzialita: 1,
                            };
                            return [4 /*yield*/, ((_e = modalAddFile.value) === null || _e === void 0 ? void 0 : _e.openModal("Aggiungi file: ", filenew, true))];
                        case 16:
                            userInput = _h.sent();
                            if (!userInput) return [3 /*break*/, 20];
                            showLoading.value = true;
                            _h.label = 17;
                        case 17:
                            _h.trys.push([17, 19, , 20]);
                            return [4 /*yield*/, saveFileFE(filenew).then(function () {
                                    var _a;
                                    showLoading.value = false;
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("File salvato con successo!", false);
                                })];
                        case 18:
                            _h.sent();
                            return [3 /*break*/, 20];
                        case 19:
                            e_1 = _h.sent();
                            showLoading.value = false;
                            console.log(e_1);
                            (_f = alertModal.value) === null || _f === void 0 ? void 0 : _f.openModal("Si è verificato un problema nel caricamento del file. Prova a riprovare più tardi. Se il problema persiste segnalalo scrivendo ad info\u0040micurobene.it", false);
                            return [3 /*break*/, 20];
                        case 20: return [3 /*break*/, 22];
                        case 21:
                            isShownModalSub.alert = true;
                            _h.label = 22;
                        case 22: return [3 /*break*/, 24];
                        case 23: return [3 /*break*/, 24];
                        case 24: return [2 /*return*/];
                    }
                });
            });
        }
        function saveFileFE(filenew) {
            return __awaiter(this, void 0, void 0, function () {
                var payload, data_1, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            payload = filenew;
                            return [4 /*yield*/, saveFile(payload)];
                        case 1:
                            data_1 = _a.sent();
                            store.fetchFiles();
                            store.fetchKardias();
                            return [3 /*break*/, 3];
                        case 2:
                            e_2 = _a.sent();
                            store.fetchFiles();
                            store.fetchKardias();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                store.fetchFiles();
                store.fetchKardias();
                return [2 /*return*/];
            });
        }); });
        var dataModelCompletati = new CollapsableModel();
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_unref(patient))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(ModalEditFile, {
                        ref_key: "modalEditFile",
                        ref: modalEditFile
                    }, null, 512),
                    _createVNode(ModalKardiaPreview, {
                        ref_key: "modalKardiaPreview",
                        ref: modalKardiaPreview
                    }, null, 512),
                    _createVNode(ModalDeleteFile, {
                        ref_key: "modalDeleteFile",
                        ref: modalDeleteFile
                    }, null, 512),
                    _createVNode(ModalConfidenzialita, {
                        ref_key: "modalConfidenzialita",
                        ref: modalConfidenzialita
                    }, null, 512),
                    _createVNode(ModalNewFile, {
                        ref_key: "modalAddFile",
                        ref: modalAddFile,
                        schema: _unref(schema)
                    }, null, 8, ["schema"]),
                    (modal_status.file_upload)
                        ? (_openBlock(), _createBlock(_unref(Modal), {
                            key: 0,
                            size: "2xl",
                            onClose: _cache[0] || (_cache[0] = function ($event) { return (modal_status.file_upload = false); })
                        }))
                        : _createCommentVNode("", true),
                    (modal_status.file_preview)
                        ? (_openBlock(), _createBlock(_unref(Modal), {
                            key: 1,
                            size: "2xl",
                            onClose: _cache[1] || (_cache[1] = function ($event) { return (modal_status.file_preview = false); })
                        }))
                        : _createCommentVNode("", true),
                    (showLoading.value)
                        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 2 }))
                        : _createCommentVNode("", true),
                    _createVNode(AlertModal, {
                        ref_key: "alertModal",
                        ref: alertModal
                    }, null, 512),
                    _createVNode(CollapsibleItem, {
                        data: _unref(kardiasschema),
                        onRowActions: action,
                        onCreateForm: _cache[2] || (_cache[2] = function ($event) { return (action('newRecord', null)); }),
                        onClick: _cache[3] || (_cache[3] = function ($event) { return (_isRef(schema) //@ts-ignore
                            ? schema.value = 'kardiasschema' : schema = 'kardiasschema'); })
                    }, null, 8, ["data"]),
                    _createVNode(CollapsibleItem, {
                        data: _unref(fileschema),
                        onRowActions: action,
                        onCreateForm: _cache[4] || (_cache[4] = function ($event) { return (action('newRecord', null)); }),
                        onClick: _cache[5] || (_cache[5] = function ($event) { return (_isRef(schema) //@ts-ignore
                            ? schema.value = 'fileschema' : schema = 'fileschema'); })
                    }, null, 8, ["data"]),
                    _createVNode(checkMeProView),
                    _createVNode(dHeart),
                    (isShownModalSub.alert)
                        ? (_openBlock(), _createBlock(_unref(Modal), {
                            key: 3,
                            onClose: _cache[8] || (_cache[8] = function ($event) { return (isShownModalSub.alert = false); })
                        }, {
                            body: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("button", {
                                        onClick: _cache[6] || (_cache[6] = function ($event) { return (isShownModalSub.alert = false); }),
                                        type: "button",
                                        class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                                    }, _toDisplayString(_ctx.$t("Annulla")), 1),
                                    _createElementVNode("button", {
                                        onClick: _cache[7] || (_cache[7] = function ($event) { return (movePage()); }),
                                        type: "button",
                                        class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                                    }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                                ])
                            ]; }),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
